export class SyncProgressEvent {
  constructor(
    // Model/service name this event refers to (matches a progressItem in the sync indicator).
    public title: string,
    // Total number of documents to sync for this service (progress-bar denominator).
    public total: number,
    // Number of documents synced so far for this service (progress-bar numerator).
    public progress: number,
    // Set on the event a service dispatches when its sync throws.
    // The sync indicator swallows the event's -1/-1 sentinel (so it does not corrupt the progress
    // bar), no longer closes on it, and flags the affected progressItem so the row shows a ✗
    // instead of a spinner.
    public isError: boolean = false,
    // Signals that every sync service has reached a terminal state (completed, errored or cancelled)
    // and the sync indicator may now close. Dispatched once per sync run by ClientDataSyncService.
    public isAllTerminal: boolean = false
  ) {}

  // UI state owned by SyncIndicatorPage, not set by sync services: becomes true on the first event
  // received for this entity in the current run, i.e. once its $limit:0 count probe has answered.
  // Before that the entity is "pending" (its service has not had its turn yet or the probe is still
  // running) and the indicator shows a spinner without numbers - a pending entity is NOT the same
  // as a finished entity with nothing to sync, even though both have progress 0 / total 0.
  public started = false;
}
